import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';
import { BoydMyBalanceComponent } from './boyd-my-balance.component';



@NgModule({
  declarations: [
    BoydMyBalanceComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule
  ],
  exports:[
    BoydMyBalanceComponent
  ]
})
export class BoydMyBalanceModule { }
